import { tokens } from '@/design';

interface ThreeDCanvasHostProps {
  description: string;
  stateNarration: string;
}

export function ThreeDCanvasHost({
  description,
  stateNarration,
}: ThreeDCanvasHostProps) {
  return (
    <div
      aria-hidden
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
      }}
    >
      <div
        id="three-d-description-region"
        role="region"
        aria-label="3D scene description"
        aria-live="polite"
        aria-atomic="false"
        style={{
          position: 'absolute',
          width: tokens.visuallyHidden.size,
          height: tokens.visuallyHidden.size,
          overflow: 'hidden',
          clipPath: 'inset(50%)',
          whiteSpace: 'nowrap',
        }}
      >
        {description}
      </div>
      <div
        id="three-d-state-region"
        role="status"
        aria-label="3D scene state narration"
        aria-live="polite"
        aria-atomic="false"
        style={{
          position: 'absolute',
          width: tokens.visuallyHidden.size,
          height: tokens.visuallyHidden.size,
          overflow: 'hidden',
          clipPath: 'inset(50%)',
          whiteSpace: 'nowrap',
        }}
      >
        {stateNarration}
      </div>
    </div>
  );
}
